import { Pipe, PipeTransform, inject } from '@angular/core';
import { PermissionService } from './permission.service';

@Pipe({ name: 'canField', pure: false, standalone: false })
export class CanFieldPipe implements PipeTransform {
  private permissionService = inject(PermissionService);


  transform(field: string): boolean {
    return this.permissionService.canField(field);
  }
}
